import isEqual from 'lodash/isEqual';
import React from 'react';
import { useListContext } from 'react-admin';
export var useDatagridAGSelectionController = function (props) {
    var gridRef = props.gridRef, onFirstDataRenderedProp = props.onFirstDataRendered, onSelectionChangedProp = props.onSelectionChanged;
    var _a = React.useState(false), hasFirstDataRendered = _a[0], setHasFirstDataRendered = _a[1];
    var _b = useListContext(props), onSelect = _b.onSelect, selectedIds = _b.selectedIds;
    // Update RA selection state when AG Grid selection changes
    var onSelectionChanged = React.useCallback(function (event) {
        onSelectionChangedProp && onSelectionChangedProp(event);
        var newSelectedIds = event.api
            .getSelectedRows()
            .map(function (row) { return row.id; });
        if (!isEqual(newSelectedIds, selectedIds)) {
            onSelect(newSelectedIds);
        }
    }, [onSelect, onSelectionChangedProp, selectedIds]);
    // Update AG Grid selection state when RA selection changes
    var updateSelectedNodes = React.useCallback(function () {
        var nodesToSelect = [];
        var nodesToUnselect = [];
        gridRef.current.api.forEachNode(function (node) {
            // node.data is defined for actual rows, but can be undefined when
            // using row grouping or during grid initialisation
            if (!node.data || !selectedIds) {
                return;
            }
            if (selectedIds.includes(node.data.id)) {
                nodesToSelect.push(node);
            }
            else {
                nodesToUnselect.push(node);
            }
        });
        gridRef.current.api.setNodesSelected({
            nodes: nodesToSelect,
            newValue: true,
        });
        gridRef.current.api.setNodesSelected({
            nodes: nodesToUnselect,
            newValue: false,
        });
    }, [selectedIds, gridRef]);
    // Update AG Grid selection state on first data render
    var onFirstDataRendered = React.useCallback(function (event) {
        onFirstDataRenderedProp && onFirstDataRenderedProp(event);
        setHasFirstDataRendered(true);
        updateSelectedNodes();
    }, [onFirstDataRenderedProp, updateSelectedNodes]);
    React.useEffect(function () {
        if (hasFirstDataRendered) {
            updateSelectedNodes();
        }
    }, [hasFirstDataRendered, updateSelectedNodes]);
    return {
        selectedIds: selectedIds,
        onSelectionChanged: onSelectionChanged,
        onFirstDataRendered: onFirstDataRendered,
    };
};
